module.exports = __webpack_public_path__ + "img/vegetable-horseradish-190x100.b60f45b5.jpg";